import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { me } from '../initial_state'
import PageTitle from '../features/ui/util/page_title'
import MarketplaceLayout from '../layouts/marketplace_layout'
import { openModal } from '../actions/modal'
import {
  MODAL_MARKETPLACE_LISTING_FILTER,
  BREAKPOINT_EXTRA_SMALL,
  CX,
  MODAL_UNAUTHORIZED,
} from '../constants'
import SidebarPanelGroup from '../components/sidebar_panel_group'
import MarketplaceListingFilterPanel from '../components/panel/marketplace_listing_filter_panel'
import MarketplaceListingCategoriesPanel from '../components/panel/marketplace_listing_categories_panel'
import TabBar from '../components/tab_bar'
import Button from '../components/button'
import Text from '../components/text'
import List from '../components/list'
import Icon from '../components/icon'
import { NavLink } from 'react-router-dom'

class MarketplaceListingPage extends React.PureComponent {

  handleOnOpenFilterModal = () => {
    const { isXS } = this.props
    this.props.dispatch(openModal(MODAL_MARKETPLACE_LISTING_FILTER, { isXS }))
  }

  handleOnOpenModal = () => {
    this.props.dispatch(openModal(MODAL_UNAUTHORIZED)) 
  }

  render() {
    const { children, isXS, page } = this.props
    
    const isDashboard = ['marketplace-listing-dashboard', 'marketplace-listing-saves'].indexOf(page) > -1

    const tabs = !!me && !isXS ? [
      {
        title: 'Home',
        to: '/marketplace',
        icon: 'shop',
        hideArrow: true,
      },
      {
        title: 'Businesses',
        to: '/businesses',
        icon: 'ul-list',
      },
      {
        title: 'My Listings',
        to: '/marketplace/dashboard',
        icon: 'apps',
        shouldHighlight: true,
        isActive: page === 'marketplace-listing-dashboard',
      },
      {
        title: 'Saved',
        to: '/marketplace/saved',
        icon: 'bookmark',
        shouldHighlight: true,
        isActive: page === 'marketplace-listing-saves',
      },
    ].filter(Boolean) : undefined
    const sidebarLayout = [
      <div key='mlpcd-1' className={[_s.d, _s.w100PC, _s.boxShadowNone, _s.boxShadowNoneBg].join(' ')}>
        <List items={tabs} size='large' padded />
      </div>,
      (<div key='mlpcd-2' className={[_s.d, _s.w100PC, _s.px5, _s.pt5].join(' ')}>
        <Button
          isBlock
          radiusSmall
          to={!!me ? '/marketplace/create' : undefined}
          onClick={!me ? this.handleOnOpenModal : undefined}
        >
          <Text color='inherit' weight='medium' size='medium' align='center'>Create Listing →</Text>
        </Button>
      </div>),
      (<div key='mlpcd-4' className={[_s.d, _s.w100PC, _s.px5, _s.pt10].join(' ')}>
        <Button
          isBlock
          radiusSmall
          backgroundColor='brandLight'
          color='brand'
          to='/marketplace/business/join'
        >
          <Text color='inherit' weight='medium' size='medium' align='center'>List your Business →</Text>
        </Button>
      </div>),
      <MarketplaceListingCategoriesPanel key='mlpcd-5' noPanel />,
    ]

    const xsTabs = !isXS ? undefined : [
      {
        title: 'My Listings',
        to: '/marketplace/dashboard',
        isActive: page === 'marketplace-listing-dashboard',
      },
      {
        title: 'Saves',
        to: '/marketplace/saved',
        isActive: page === 'marketplace-listing-saves',
      },
    ]

    const actions = isXS && !isDashboard ? [
      {
        attrTitle: 'Create new listing',
        icon: 'add',
        to: '/marketplace/create',
      },
      {
        attrTitle: 'Sort and Filter',
        icon: 'search',
        onClick: this.handleOnOpenFilterModal
      }
    ] : undefined

    const wrapperClasses = CX({
      d: 1,
      w100PC: 1,
      px15: !isXS && isDashboard,
    })


    // marketplace listing related listings panel
    // marketplace listing category listings panel

    const title = 
      page === 'marketplace-listing-dashboard' && isXS ? 'Marketplace Dashboard' : 
      page === 'marketplace-listing-saves' ? 'Saved listings' : 'Marketplace'

    return (
      <MarketplaceLayout
        page='marketplace'
        title={title}
        actions={actions}
        showBackBtn
        sidebarChildren={<SidebarPanelGroup layout={sidebarLayout} />}
        noRightSidebar
      >
        <PageTitle path='Marketplace' />
        <div className={wrapperClasses}>

          {
            isXS && isDashboard &&
            <div className={[_s.d, _s.w100PC, _s.h40PX, _s.z6, _s.top0, _s.right0, _s.left0, _s.posSticky, _s.bgPrimary, _s.borderBottom1PX, _s.borderColorSecondary].join(' ')}>
              <TabBar tabs={xsTabs} shouldGrow />
            </div>
          }

          {children}
        </div>
      </MarketplaceLayout>
    )
  }

}

const mapStateToProps = (state) => ({
  isXS: state.getIn(['settings', 'window_dimensions', 'width']) <= BREAKPOINT_EXTRA_SMALL,
})

MarketplaceListingPage.propTypes = {
  children: PropTypes.node.isRequired,
  isXS: PropTypes.bool.isRequired,
  page: PropTypes.string,
}

export default connect(mapStateToProps)(MarketplaceListingPage)